import React from 'react'
import { Link } from 'react-router-dom'
import Loader from '../../Loader'

class PaymentTypeAdd extends React.Component {
  state = {
    status: true,
    description: '',
    title: 'Full Payment',
  }
  onHandleDescriptionChange = (value) => {
    this.setState({ description: value })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onSaveData = () => {}
  uploadMedia = () => {}

  render() {
    return (
      <div className="">
        {this.state.isLoading ? (
          <Loader />
        ) : (
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">PaymentType Name</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      id="title"
                      placeholder="PaymentType Name"
                      onChange={this.handleChange}
                      value={this.state.title}
                    />
                  </div>
                </div>
              </div>

              {/* <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Payment Type</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="type"
                        id="type"
                        placeholder="Payment Type"
                        onChange={this.handleChange}
                        value={this.state.type}
                      />
                    </div>
                  </div>
                </div> */}

              <div className="col-md-6">
                <div className="row">
                  <div className="col-sm-3">Display Image</div>
                  <div className="col-sm-9">
                    <form
                      id="payment_typeImage"
                      name="payment_typeImage"
                      encType="multipart/form-data"
                      className="text-capitalize"
                    >
                      <div className="form-group">
                        {/* <input onChange={this.handleChange} id="shop_Image" type="text" className="form-control" name="image" /> */}
                        <input
                          accept="image/*"
                          onChange={this.handleImageUpload}
                          id="payment_type_image"
                          type="file"
                          className="form-control"
                          autoComplete="off"
                          name="media"
                          data-toggle="tooltip"
                          title="Click To Upload Banner Image"
                        />
                      </div>
                    </form>
                  </div>
                </div>
                <div
                  id="payment_type_image_label"
                  className="pt-2"
                >
                  {this.state.image ? (
                    this.state.image !== null || this.state.image !== undefined || this.state.image !== {} ? (
                      <img
                        src={this.state.image}
                        alt=""
                        className="img-100"
                        onError={(e) => {
                          e.target.src = ''
                        }}
                      />
                    ) : (
                      ''
                    )
                  ) : (
                    ''
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Status</label>
                  <div className="col-sm-9">
                    <select
                      name="status"
                      className="form-control"
                      value={this.state.status}
                      onChange={this.handleChange}
                    >
                      <option
                        value="true"
                        name="active"
                      >
                        Active
                      </option>
                      <option
                        value="false"
                        name="inactive"
                      >
                        Inactive
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="row">
            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-sm-2 col-form-label">Description</label>
                <div className="col-sm-10">
                  <ReactQuill
                    value={this.state.description}
                    onChange={this.onHandleDescriptionChange}
                    style={{ height: "200px", marginBottom: '5%' }}
                  />
                </div>
              </div>
            </div>
          </div>
          */}
            <div className="card-footer">
              <div className="row float-right p-3">
                {this.state.isSaving ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn btn-grd-disabled mr-2"
                  >
                    <i className="icofont icofont-save"></i> Save
                  </button>
                )}
                <Link
                  to={'/payment-type'}
                  className="btn btn-outline-dark"
                >
                  Cancel
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default PaymentTypeAdd
